<template>
  <div>
    <div class="row mb-4">
      <div
        v-if="profile === 'SUPPLIER'"
        class="col-md col-6 mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'sales' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/sales.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>{{ $t('myCabinetMenu.satVReytinq') }}</h6>
                <p>{{ $t('myCabinetMenu.qeydAlnmSatlarnzVSatnalmalarnQiymtlndirilmsi') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile === 'PROCUREMENT'"
        class="col-md col-6 mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'purchases' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/purcahse.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>{{ $t('myCabinetMenu.alVReytinq') }}</h6>
                <p>{{ $t('myCabinetMenu.qeydAlnmAllarnzVTdarklrinQiymtlndirilmsi') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md col-12 mb-3">
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'myRequests', query: { status: 'ALL' } })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/requests.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6 class="f-w-600">
                  {{ $t('myCabinetMenu.sorular') }}
                </h6>
                <p>{{ $t('myCabinetMenu.trfinizdnPlatformadaYerldirilmiSorularnIdaretmsi') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile !== 'PROCUREMENT' && (isAdmin || companyUserStatus === 'verified')"
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'vendorManagementOutgoingRequests' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/vendor-reqeusts.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>{{ $t('myCabinetMenu.tdarkMracitlrim') }}</h6>
                <p>{{ $t('myCabinetMenu.tdarkDyrlndirmFormalarnaGndrdiyinizMracitlr') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile !== 'PROCUREMENT'"
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'vendorManagementCustomerRequests' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/customer-requests.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>
                  {{ $t('myCabinetMenu.mtrilriminSorular') }}
                  <span class="badge bg-success blink">
                    <img
                      src="@/assets/images/icons/bolt.png"
                      alt="bolt"
                    >
                    {{ $t('myCabinetMenu.yeni') }}
                  </span>
                </h6>
                <p>
                  {{ $t('myCabinetMenu.tsdiqlnmiTdarksOlduunuzTkilatlarnSorular') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile !== 'PROCUREMENT'"
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'myProductsPage' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/shopping.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>
                  {{ $t("myCabinetMenu.products") }}
                  <span
                    v-if="inquiry"
                    class="badge bg-success blink"
                  >
                    <img
                      src="@/assets/images/icons/bolt.png"
                      alt="bolt"
                    >
                    {{ $t('myCabinetMenu.yeni') }}
                  </span>
                </h6>
                <p>
                  {{ $t('myCabinetMenu.search') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="profile === 'PROCUREMENT' && (isAdmin || companyUserStatus === 'verified')"
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'vendorManagementDashboard' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/vendors.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>{{ $t('myCabinetMenu.tdarklrinIdarEdilmsi') }}</h6>
                <p>{{ $t('myCabinetMenu.tdarkDyrlndirmFormalarVTdarklrinIdaredilmsi') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile === 'PROCUREMENT' && (isAdmin || companyUserStatus === 'verified')"
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'vendorManagementReports' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/reports.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>{{ $t('myCabinetMenu.hesabatlar') }}</h6>
                <p>{{ $t('myCabinetMenu.qiymtSorularVAllarlaBalHesabatlar') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="profile === 'PROCUREMENT' && isAdmin && vendorManagmentStatus"
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({ name: 'userPermissions' })"
        >
          <div class="card-body">
            <div class="cabinet-item">
              <img
                src="../../assets/images/icons/dashboard/user-permissions.png"
                class="cabinet-item-icon"
                alt="cabinet-item-icon"
              >
              <div class="cabinet-item-content">
                <h6>{{ $t('myCabinetMenu.istifadecilerinIcazeleri') }}</h6>
                <p>{{ $t('myCabinetMenu.istifadecilerinIcazeleriDescription') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-4">
      <div
        v-if="profile === 'PROCUREMENT'"
        class="col-md mb-3"
      >
        <div
          class="card h-100 mb-0 pointer product-search-card"
          @click.prevent="$router.push({ name: 'productSearch' })"
        >
          <div class="card-body">
            <div class="search-title">
              <h1 class="search-text">
                {{ $t('myCabinetMenu.fastSearch') }}
                <i class="fa fa-search search-icon" />
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfileName } from "@/repositories/Utils";
import { mapState } from "vuex";
import { getNewInquiry } from "@/repositories/ProductDataRepository";

export default {
  name: 'MyCabinetMenu',
  props: {
    profile: {},
    vendorManagmentStatus:{},
    requestStatusStatistics: {}
  },
  data() {
    return {
      inquiry: false
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.auth.isAdmin,
      companyUserStatus: state => state.auth.companyUserStatus,
      token: state => state.auth.token,
    })
  },
  mounted() {
    this.hasNewInquiry();
  },
  methods: {
    getProfileName(keyword) {
      return getProfileName(keyword, this.$i18n);
    },
    hasNewInquiry() {
      getNewInquiry(this.token).then(data => {
        if (data.code === 200) {
          this.inquiry = data.hasNewInquiry;
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme/_variables.scss";

// Section title
.section-title {
  font-size: 24px;
  font-weight: 600;
  color: $theme-font-color;
  margin-bottom: 1.5rem;
  position: relative;
  padding-left: 15px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 24px;
    background: linear-gradient(to bottom, $primary-color, lighten($primary-color, 20%));
    border-radius: 3px;
  }
}

// Card styling
.card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  position: relative;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, rgba($primary-color, 0.1), rgba($primary-color, 0.2));
    border-radius: 50%;
    opacity: 0;
    transform: scale(0);
    transform-origin: top right;
    transition: opacity 0.5s ease, transform 0.5s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);

    &::before {
      opacity: 1;
      transform: scale(2.5);
    }
  }

  &.pointer {
    cursor: pointer;

    &:active {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
}

.card-body {
  padding: 1.5rem;
}

.cabinet-item {
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  z-index: 2;

  .cabinet-item-icon {
    width: 50px;
    height: 50px;
    margin-right: 20px;
    padding: 6px;
    background-color: rgba($primary-color, 0.08);
    border-radius: 10px;
    object-fit: contain;
    transition: all 0.25s ease;
    border: 1px solid transparent;

    .card:hover & {
      background-color: rgba($primary-color, 0.15);
      transform: scale(1.05);
    }
  }

  .cabinet-item-content {
    flex: 1;
    min-width: 0; // Ensures text truncation works properly
    overflow: hidden; // Prevents content from overflowing
  }

  h6 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    color: $theme-font-color;
    transition: color 0.2s ease;

    .card:hover & {
      color: $primary-color;
    }

    .badge {
      margin-left: 8px;
      padding: 0.4em 0.7em;
      font-size: 0.75em;
      font-weight: 500;
      border-radius: 50px;
      vertical-align: middle;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: transform 0.2s ease;

      &.bg-success {
        background-color: $success-color !important;
      }

      &.blink {
        animation: pulse 2s infinite;
      }

      img {
        width: 10px;
        height: 10px;
        margin-right: 3px;
      }
    }
  }

  p {
    font-size: 14px;
    margin-bottom: 0;
    color: $theme-body-sub-title-color;
    line-height: 1.5;
    transition: color 0.2s ease;

    .card:hover & {
      color: darken($theme-body-sub-title-color, 10%);
    }
  }
}

.product-search-card {
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border: 1px solid rgba($primary-color, 0.1);

  &:hover {
    background: linear-gradient(135deg, #f1f3f9, #ffffff);
    border-color: rgba($primary-color, 0.2);
  }
}

.search-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 1rem;
}

.search-text {
  font-size: 24px;
  font-weight: 500;
  margin: 0;
  color: $primary-color;
  transition: all 0.3s ease;

  .card:hover & {
    transform: scale(1.05);
  }
}

.search-icon {
  font-size: 24px;
  margin-left: 10px;
  color: $primary-color;
  transition: all 0.3s ease;

  .card:hover & {
    transform: rotate(15deg);
  }
}

// Animation keyframes
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba($success-color, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba($success-color, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($success-color, 0);
  }
}
</style>
